// paquetes
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
// componentes
import CardServicio from "./cardServicio";
// funciones
import { eventoClickServicioRelacionado } from "../funcionesDatos/eventoPropio";
import { pixelClickServicioRelacionado } from "../funcionesDatos/pixelFacebook";
import { gtagClickServicioRelacionado } from "../funcionesDatos/pixelGoogle";
// estilos
import "../estilos/usuario.css"; // .sliderRelacionados

// Bloques "Más servicios de este vendedor" y "Servicios similares" al final de verServicio.jsx.
// Datos: /obtener-servicios-relacionados (backend/routes/servicios.js).
// Va al final de la página a propósito, lejos del botón de reservar: no debe competir con el
// servicio que el comprador está viendo (muchos vendedores comparten el link de su propio servicio).
// Props:
// - idServicio: servicio que se está viendo
// - nombreVendedor: para el título del bloque del vendedor (opcional)
// - usuario: usuario logueado (opcional, solo para el evento de medición)

const LIMITE = 5;
const CABEN_EN_ESCRITORIO = 4; // tarjetas de 270px en el container de 1140px: con más, mostramos flechas

function ServiciosRelacionados({ idServicio, nombreVendedor, usuario }) {
    const [delVendedor, setDelVendedor] = useState([]);
    const [similares, setSimilares]     = useState([]);
    const [ciudad, setCiudad]           = useState(null);
    const sliders                       = useRef({}); // { vendedor: <div>, similares: <div> }

    useEffect(() => {
        if (!idServicio) return;
        let cancelado = false;

        (async () => {
            try {
                const res = await axios.post("/obtener-servicios-relacionados", { params: { idServicio, limite: LIMITE } });
                if (cancelado) return;
                setDelVendedor(Array.isArray(res?.data?.delVendedor) ? res.data.delVendedor : []);
                setSimilares(Array.isArray(res?.data?.similares) ? res.data.similares : []);
                setCiudad(res?.data?.ciudad || null);
            }
            catch (err) {
                // Silencioso: si falla, la página del servicio sigue igual, solo sin estos bloques.
                console.log("Error cargando servicios relacionados:", err);
                if (!cancelado) { setDelVendedor([]); setSimilares([]); }
            }
        })();

        return () => { cancelado = true; };
    }, [idServicio]);


    // Registra el clic (evento propio + Meta + GA4) antes de que CardServicio navegue
    // (capture: corre antes que su onClick).
    function registrarClick(bloque, servicio, posicion) {
        const paquete = Array.isArray(servicio?.paquetes) ? servicio.paquetes[0] : null;
        const datos = {
            bloque,
            idOrigen:  idServicio,
            idDestino: servicio?.idServicio,
            nombre:    servicio?.nombre,
            categoria: servicio?.categoria,
            precio:    paquete?.totalClienteDesde || paquete?.precio || 0,
            posicion,
        };

        eventoClickServicioRelacionado({ ...datos, usuarioId: usuario?.idUsuario });
        pixelClickServicioRelacionado(datos);
        gtagClickServicioRelacionado(datos);
    }


    // Flechas (solo escritorio): desliza casi un "ancho" visible del slider.
    function deslizar(bloque, direccion) {
        const el = sliders.current[bloque];
        if (!el) return;
        el.scrollBy({ left: direccion * el.clientWidth * 0.9, behavior: "smooth" });
    }


    function renderBloque({ titulo, subtitulo, servicios, bloque }) {
        if (!servicios.length) return null;

        return (
            <div className="mt-5">
                <div className="d-flex justify-content-between align-items-end flex-wrap gap-2 mb-3">
                    <div>
                        <h4 className="mb-0 text-dark">{titulo}</h4>
                        {subtitulo ? <small className="text-muted">{subtitulo}</small> : null}
                    </div>

                    {servicios.length > CABEN_EN_ESCRITORIO ? (
                        <div className="d-none d-md-flex gap-2">
                            <button type="button" className="btn btn-sm btn-outline-primary rounded-circle" style={{ width: 36, height: 36 }} onClick={() => deslizar(bloque, -1)} aria-label="Anteriores">
                                <i className="bi bi-chevron-left"></i>
                            </button>
                            <button type="button" className="btn btn-sm btn-outline-primary rounded-circle" style={{ width: 36, height: 36 }} onClick={() => deslizar(bloque, 1)} aria-label="Siguientes">
                                <i className="bi bi-chevron-right"></i>
                            </button>
                        </div>
                    ) : null}
                </div>

                <div className="sliderRelacionados" ref={(el) => { sliders.current[bloque] = el; }}>
                    {servicios.map((s, idx) => (
                        <div className="sliderRelacionadosItem" key={s.idServicio} onClickCapture={() => registrarClick(bloque, s, idx)}>
                            <CardServicio servicio={s} clampDesc={2} textoBoton="Ver servicio" desdeDonde="home" />
                        </div>
                    ))}
                </div>
            </div>
        );
    }


    if (!delVendedor.length && !similares.length) return null;

    return (
        <div>
            {renderBloque({
                titulo: nombreVendedor ? `Más servicios de ${nombreVendedor}` : "Más servicios de este vendedor",
                servicios: delVendedor,
                bloque: "vendedor",
            })}

            {renderBloque({
                titulo: ciudad ? `Servicios similares en ${ciudad}` : "Servicios similares",
                subtitulo: "Otras opciones que también te pueden servir",
                servicios: similares,
                bloque: "similares",
            })}
        </div>
    );
}



export default ServiciosRelacionados;
